import { createUseStyles } from 'react-jss'

const useStyles = createUseStyles({
  content: {
    display: 'flex',
    flex: 1,
    flexDirection: 'column',
  },
})

export default useStyles
